import { BottomSheet, Icon, type IconName } from "@helmr/ui";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../permissions";
import { mobile } from "./strings";
import { handOverSentinel, useSheetBack } from "./useSheetBack";
import s from "./mobile.module.css";

interface Action { key: string; label: string; icon: IconName; tone: "info" | "ok" | "violet" | "warn" | "crit" | "teal"; show: boolean; go: string | "search" }

/**
 * The centre + sheet. Each action shows by permission and goes to its area (which says "coming soon" until its slice
 * lands). Check in member opens the member search only: there is no manual check-in route (founder question 5).
 */
export function FabSheet({ open, onOpenChange, onSearchMembers }: { open: boolean; onOpenChange: (o: boolean) => void; onSearchMembers: () => void }) {
  const { has } = useAppContext();
  const navigate = useNavigate();
  useSheetBack(open, () => onOpenChange(false));
  const t = mobile.fab;
  const actions: Action[] = [
    { key: "member", label: t.newMember, icon: "users", tone: "info", show: has("members.add"), go: "/members?new=1" },
    { key: "payment", label: t.collect, icon: "cash", tone: "ok", show: has("billing.create_bill"), go: "/billing?new=1" },
    { key: "checkin", label: t.checkin, icon: "finger", tone: "teal", show: has("members.view"), go: "search" },
    { key: "trial", label: t.trial, icon: "trial", tone: "violet", show: has("leads.add"), go: "/leads?trial=1" },
    { key: "task", label: t.task, icon: "check", tone: "warn", show: true, go: "/home?task=1" },
    { key: "expense", label: t.expense, icon: "receipt", tone: "crit", show: has("expenses.add"), go: "/expenses?new=1" },
  ];
  return (
    <BottomSheet open={open} onOpenChange={onOpenChange} title={t.title} description={t.sub}>
      <div className={s.acts6}>
        {actions.filter((a) => a.show).map((a) => (
          <button key={a.key} type="button" onClick={() => { onOpenChange(false); if (a.go === "search") onSearchMembers(); else { handOverSentinel(); navigate(a.go, { replace: true }); } }}>
            <span className={s.ti} data-tone={a.tone}><Icon name={a.icon} size={22} /></span>
            {a.label}
          </button>
        ))}
      </div>
    </BottomSheet>
  );
}
